
// TOP スライダー
const swiper = new Swiper(".swiper", {
  loop: true, // ループ
  speed: 1500, // 少しゆっくり(デフォルトは300)
  slidesPerView: 2.5, // 一度に表示する枚数
  spaceBetween: 10, // スライド間の距離
  centeredSlides: true, // アクティブなスライドを中央にする
  autoplay: {
    // 自動再生
    delay: 1000, // 1秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // 前後の矢印
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 750px以下の場合
    750: {
      spaceBetween: 30,
    },
  },
});


// 商品詳細 cartドロワー
var addToCartButton = document.getElementById('add-to-cart-button');
var drawerMenu = document.getElementById('drawer-menu');
var overlay = document.getElementById('overlay');

addToCartButton.addEventListener('click', function(event) {
  event.preventDefault(); // フォームの送信を防ぐ場合
  drawerMenu.classList.toggle('open');
  addToCartButton.classList.toggle('hidden');
  overlay.classList.toggle('hidden');
  setTimeout(function() { overlay.classList.toggle('open'); }, 10); // アニメーションのための遅延
});

document.addEventListener('click', function(event) {
  var isClickInside = drawerMenu.contains(event.target);
  var isButtonClick = event.target.id === 'add-to-cart-button';

  if (!isClickInside && !isButtonClick && drawerMenu.classList.contains('open')) {
    drawerMenu.classList.remove('open');
    addToCartButton.classList.remove('hidden');
    overlay.classList.remove('open');
    setTimeout(function() { overlay.classList.add('hidden'); }, 300); // アニメーションのための遅延
  }
});